import { render, staticRenderFns } from "./Repositories.vue?vue&type=template&id=58ab3cd6&"
import script from "./Repositories.vue?vue&type=script&lang=js&"
export * from "./Repositories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports